import rolesApi from 'Api/axios/roles-api';

const useUpdate = ({ data, cancel, allRoles, setAllRoles }) => {
  const handleClick = async () => {
    const patchData = {
      name: data.name,
      active: !data.active,
    };
    const response = await rolesApi.patch(String(data.id), patchData);
    if (response.error) alert('FATAL ERROR');
    cancel();
  };

  return {
    handleClick,
  };
};

export default useUpdate;
